module.exports = __webpack_public_path__ + "img/uah_fiatrail.c743fc6.png";